import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import adicionarFiltroPedido from '../../actions/pedido/adicionarFiltroPedido'
import removerFiltroPedido from '../../actions/pedido/removerFiltroPedido'
import { listarFiltrosPedidos } from '../../actions/pedido/pedidoGeralController'
import {
  FILTRO_AGENCIA,
  FILTRO_SITUACAO_BPE,
  FILTRO_CPF,
  FILTRO_DATA_EMBARQUE,
  FILTRO_DATA_VENDA,  
  FILTRO_FORMA_PAGAMENTO,
  FILTRO_NUMERO_PEDIDO,
  FILTRO_ROTA,
  FILTRO_SITUACAO_PEDIDO,
  FILTRO_TRECHO_DESTINO,
  FILTRO_TRECHO_ORIGEM,
  FILTRO_VENDEDOR,
  FILTRO_NUMERO_RESERVA,
  FILTRO_SEGURO,
  FILTRO_NUMERO_SEGURO,
  FILTRO_PLATAFORMA,
  FILTRO_NOME_PASSAGEIRO,
  FILTRO_VENDEDOR_ADMINAGENCIA,
  FILTRO_HORA_PARTIDA_ITINERARIO,
  FILTRO_EMPRESAS,
  FILTRO_ORIGEM_REMARCACAO,
  FILTRO_HORARIO_EXTRA
} from '../../util/filtros'
import { alterouEmpresa } from '../../actions/empresa/alterarEmpresaSelecionada';
import FiltroChaveValor from '../comum/FiltroChaveValor';
import { getAdminEmpresa, getGestorEmpresa, getOperadorEmpresa, getFinanceiroEmpresa, PERFIL_ADMIN } from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';

import FiltroBuscaPedido from './FiltroBuscaPedido';
import { tipoSituacaoTransmissaoBpe } from '../../util/constantsUtil';

export class FiltroPedidos extends Component {
  componentDidMount() {
    if (this.props.empresaSelecionada && this.props.empresaSelecionada.id) {
      this.props.listarFiltrosPedidos(this.props.empresaSelecionada.id)
    }
  }

  componentDidUpdate(prevProps) {
    if (alterouEmpresa(this.props, prevProps)) {
      this.props.listarFiltrosPedidos(this.props.empresaSelecionada.id)
    }
  }


  adicionarFiltro(filtro) {
    this.props.adicionarFiltroPedido(filtro)
  }

  removerFiltro(filtro) {
    this.props.removerFiltroPedido(filtro)
  }

  render() {
    if (!this.props.vendedores) {
      return <div>Carregando...</div>
    }

    return (
      <React.Fragment>
        <div className="conteudo">
          <FiltroBuscaPedido
            filtro={FILTRO_NUMERO_PEDIDO}
            isNumero={true}
          />
          <FiltroBuscaPedido
            filtro={FILTRO_NUMERO_RESERVA}
            isNumero={true}
          />
          <FiltroBuscaPedido
            filtro={FILTRO_NUMERO_SEGURO}
            isNome={true}
          />
          <FiltroBuscaPedido
            filtro={FILTRO_SEGURO}
            opcoes={['Com seguro', 'Sem seguro']}
            isRadio={true}
          />
          <FiltroBuscaPedido
            filtro={FILTRO_ORIGEM_REMARCACAO}
            opcoes={['Sim']}
            isRadio={true}
          />
          <FiltroBuscaPedido
            filtro={FILTRO_HORARIO_EXTRA}
            opcoes={['Sim']}
            isRadio={true}
          />
          <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
            <FiltroBuscaPedido
              filtro={FILTRO_PLATAFORMA}
              opcoes={this.props.plataformas}
            />
          </Autorizacao>
          <FiltroBuscaPedido
            filtro={FILTRO_NOME_PASSAGEIRO}
            isNome={true}
          />
          <FiltroBuscaPedido
            filtro={FILTRO_CPF}
            isCpf={true}
          />
          <FiltroChaveValor
            filtro={FILTRO_SITUACAO_PEDIDO}
            opcoes={this.props.situacoes}
            filtrosAdicionados={this.props.filtrosAdicionados}
            adicionarFiltro={this.adicionarFiltro.bind(this)}
            removerFiltro={this.removerFiltro.bind(this)}
          />

          <FiltroChaveValor
            filtro={FILTRO_FORMA_PAGAMENTO}
            opcoes={this.props.formasPagamento}
            filtrosAdicionados={this.props.filtrosAdicionados}
            adicionarFiltro={this.adicionarFiltro.bind(this)}
            removerFiltro={this.removerFiltro.bind(this)}
          />

          <FiltroBuscaPedido
            filtro={FILTRO_AGENCIA}
            opcoes={[]}
            isNome={true}
          />
          <FiltroBuscaPedido
            filtro={FILTRO_DATA_EMBARQUE}
            opcoes={[new Date().getFullYear()]}
            isFiltroData={true}
          />
          <FiltroBuscaPedido
            filtro={FILTRO_HORA_PARTIDA_ITINERARIO}
            opcoes={[]}
            isFiltroHora={true}
          />          
          <FiltroChaveValor
            filtro={FILTRO_EMPRESAS}
            opcoes={this.props.empresas}
            filtrosAdicionados={this.props.filtrosAdicionados}
            adicionarFiltro={this.adicionarFiltro.bind(this)}
            removerFiltro={this.removerFiltro.bind(this)}
          />          
          <FiltroBuscaPedido
            filtro={FILTRO_DATA_VENDA}
            opcoes={[new Date().getFullYear()]}
            isFiltroData={true}
          />
          <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
            getOperadorEmpresa(this.props.empresaSelecionada.id),
            getAdminEmpresa(this.props.empresaSelecionada.id),
            getGestorEmpresa(this.props.empresaSelecionada.id)]}>
            <FiltroBuscaPedido
              filtro={FILTRO_VENDEDOR}
              opcoes={[]}
              isNome={true}
            />
          </Autorizacao>
          <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
            <FiltroBuscaPedido
              filtro={FILTRO_VENDEDOR_ADMINAGENCIA}
              opcoes={[]}
              isNome={true}
            />
          </Autorizacao>
          <FiltroBuscaPedido
            filtro={FILTRO_ROTA}
            opcoes={[]}
            isNome={true}
          />

          <FiltroBuscaPedido
            filtro={FILTRO_TRECHO_ORIGEM}
            opcoes={[]}
            isNome={true}
          />
          <FiltroBuscaPedido
            filtro={FILTRO_TRECHO_DESTINO}
            opcoes={[]}
            isNome={true}
          />

          <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
            getAdminEmpresa(this.props.empresaSelecionada.id),
            getGestorEmpresa(this.props.empresaSelecionada.id),
            getFinanceiroEmpresa(this.props.empresaSelecionada.id)]}>
            <FiltroChaveValor
              filtro={FILTRO_SITUACAO_BPE}
              opcoes={tipoSituacaoTransmissaoBpe}
              filtrosAdicionados={this.props.filtrosAdicionados}
              adicionarFiltro={this.adicionarFiltro.bind(this)}
              removerFiltro={this.removerFiltro.bind(this)}
            />
          </Autorizacao>
        </div>
      </React.Fragment>
    )
  }
}

export const mapStateToProps = (state) => ({
  vendedores: state.filtrosPedidos.vendedores,
  rotas: state.filtrosPedidos.rotas,
  plataformas: state.filtrosPedidos.plataformas,
  situacoes: state.filtrosPedidos.situacoes,
  trechos: state.filtrosPedidos.trechos,
  agencias: state.filtrosPedidos.agencias,
  empresas: state.filtrosPedidos.empresas,
  formasPagamento: state.filtrosPedidos.formasPagamento,
  filtrosAdicionados: state.filtrosAdicionadosPedido,
  empresaSelecionada: state.empresaSelecionada

})

export const mapDispatchToProps = dispatch => (
  bindActionCreators({
    adicionarFiltroPedido,
    removerFiltroPedido,
    listarFiltrosPedidos
  }, dispatch)
)

export default connect(mapStateToProps, mapDispatchToProps)(FiltroPedidos)
